/**
 * Configuración de contacto para el frontend
 * Los valores se cargan desde variables de entorno
 */

export const contactConfig = {
  // Información de contacto
  email: import.meta.env.VITE_CONTACT_EMAIL || 'contacto@shalom-app.com',
  name: import.meta.env.VITE_CONTACT_NAME || 'Equipo Shalom',
  phone: import.meta.env.VITE_CONTACT_PHONE || '+593 99 123 4567',
  whatsapp: import.meta.env.VITE_CONTACT_WHATSAPP || '593991234567', // Sin + ni espacios
  
  // Horario de atención
  schedule: 'Lunes a Viernes, 9:00 AM - 6:00 PM (GMT-5)',
  
  // Redes sociales (opcional)
  social: {
    facebook: '',
    instagram: '',
    twitter: '',
    youtube: ''
  }
};






